import { LegalPage } from "@/components/LegalPage";
import { PRIVACY } from "@/data/legal";

export default function Privacy() {
  return <LegalPage policy={PRIVACY} />;
}
